import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=7179738d&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=7179738d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179738d",
  null
  
)

export default component.exports